(function() {
    'use strict';
    
    /**
     * Service pour les données du Budget de l'État 2025
     * Fournit les données détaillées des recettes et dépenses du budget
     */
    angular
        .module('observatoireApp')
        .factory('BudgetDataService', BudgetDataService);
        
    function BudgetDataService() {
        // Données des recettes fiscales
        const recettesFiscales = [
            { 
                code: 1, 
                nom: "Recettes fiscales", 
                prevision: 1248600000 
            },
            { 
                code: 2, 
                nom: "Dons, legs et fonds de concours", 
                prevision: 193800000 
            },
            { 
                code: 3, 
                nom: "Cotisations sociales", 
                prevision: 0 
            },
            { 
                code: 4, 
                nom: "Autres recettes", 
                prevision: 442400000 
            }
        ];
        
        // Données des dépenses d'investissement
        const depensesInvestissement = [
            { 
                code: 1, 
                nom: "Charges financières", 
                prevision: 15490500 
            },
            { 
                code: 2, 
                nom: "Dépenses de personnel", 
                prevision: 1020000000 
            },
            { 
                code: 3, 
                nom: "Dépenses de biens et services", 
                prevision: 1020000000 
            },
            { 
                code: 4, 
                nom: "Dépenses de transfert", 
                prevision: 836256114.7
            },
            { 
                code: 5, 
                nom: "Dépenses d'investissement", 
                prevision: 1196100000 
            },
            { 
                code: 6, 
                nom: "Autres dépenses", 
                prevision: 0 
            }
        ];
        
        // Calcul des statistiques
        function calculerStatistiques(donnees) {
            if (!donnees || donnees.length === 0) {
                return {
                    total: 0,
                    moyenne: 0,
                    max: { code: 0, nom: "", valeur: 0 },
                    min: { code: 0, nom: "", valeur: 0 }
                };
            }
            
            let total = 0;
            let max = { code: 0, nom: "", valeur: 0 };
            let min = { code: 0, nom: "", valeur: Number.MAX_VALUE };
            
            donnees.forEach(function(item) {
                total += item.prevision;
                
                if (item.prevision > max.valeur) {
                    max = { code: item.code, nom: item.nom, valeur: item.prevision };
                }
                
                if (item.prevision < min.valeur && item.prevision > 0) {
                    min = { code: item.code, nom: item.nom, valeur: item.prevision };
                }
            });
            
            return {
                total: total,
                moyenne: total / donnees.length,
                max: max,
                min: min
            };
        }
        
        // Statistiques pour les recettes
        const statsRecettes = calculerStatistiques(recettesFiscales);
        
        // Statistiques pour les dépenses
        const statsDepenses = calculerStatistiques(depensesInvestissement);
        
        // Convertir les données pour les graphiques (camembert, barres, etc.)
        function preparerDonneesGraphique(donnees, type) {
            // Filtrer les éléments avec prévision à 0
            const donneesFiltered = donnees.filter(item => item.prevision > 0);
            
            if (type === 'pie' || type === 'radar') {
                return {
                    labels: donneesFiltered.map(item => item.nom),
                    data: donneesFiltered.map(item => item.prevision),
                    colors: [
                        "#4e5bc4", "#6c30a8", "#9d32a8", "#2a3990", 
                        "#1475bb", "#5a6acf", "#32a852", "#a83260"
                    ].slice(0, donneesFiltered.length)
                };
            } else if (type === 'bar' || type === 'line') {
                return {
                    labels: donneesFiltered.map(item => item.nom),
                    datasets: [{
                        label: 'Prévision 2025 (FCFA)',
                        data: donneesFiltered.map(item => item.prevision),
                        backgroundColor: [
                            "#4e5bc4", "#6c30a8", "#9d32a8", "#2a3990", 
                            "#1475bb", "#5a6acf", "#32a852", "#a83260"
                        ].slice(0, donneesFiltered.length),
                        borderColor: '#2a3990',
                        borderWidth: 1
                    }]
                };
            }
            
            return { labels: [], data: [] };
        }
        
        // Méthodes exposées par le service
        return {
            getRecettesFiscales: function() {
                return angular.copy(recettesFiscales);
            },
            
            getDepensesInvestissement: function() {
                return angular.copy(depensesInvestissement);
            },
            
            getStatsRecettes: function() {
                return angular.copy(statsRecettes);
            },
            
            getStatsDepenses: function() {
                return angular.copy(statsDepenses);
            },
            
            getRecettesGraphData: function(type) {
                return preparerDonneesGraphique(recettesFiscales, type);
            },
            
            getDepensesGraphData: function(type) {
                return preparerDonneesGraphique(depensesInvestissement, type);
            },
            
            // Pour le téléchargement des données en CSV
            getDataForExport: function(typeData) {
                if (typeData === 'recettes-fiscales') {
                    return recettesFiscales.map(function(recette) {
                        return {
                            'Code': recette.code,
                            'Nom': recette.nom,
                            'Prévision (FCFA)': recette.prevision
                        };
                    });
                } else if (typeData === 'depenses-investissement') {
                    return depensesInvestissement.map(function(depense) {
                        return {
                            'Code': depense.code,
                            'Nom': depense.nom,
                            'Prévision (FCFA)': depense.prevision
                        };
                    });
                }
                return [];
            }
        };
    }
})();
